{
  "anonymousConsents": {
    "preferences": "Consent Preferences",
    "dialog": {
      "title": "Consent Management",
      "legalDescription": "We use cookies/browser's storage to personalize the content and improve user experience. We also might share the data about your site usage with our social media. For more, please review our privacy policy.",
      "selectAll": "Select all",
      "clearAll": "Clear all"
    },
    "banner": {
      "title": "This website uses cookies",
      "description": "We use cookies/browser's storage to personalize the content and improve user experience.",
      "allowAll": "Allow All",
      "viewDetails": "View Details"
    }
  },
  "forgottenPassword": {
    "resetPassword": "Passwort zurücksetzen",
    "enterEmailAddressAssociatedWithYourAccount": "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein",
    "emailAddress": {
      "label": "Nutzerkennung *",
      "placeholder": "Nutzerkennung"
    },
    "enterValidEmail": "Bitte geben Sie eine gültige Email-Adresse ein.",
    "passwordResetEmailSent": "Ein neues Passwort wird an die bei der RINGFOTO-Zentrale gespeicherte Standard-E-Mail Adresse gesendet. Bitte folgen Sie den Anweisungen in der E-Mail.",
    "passwordResetSuccess": "Success! Sie können sich nun mit Ihrem neuen Passwort anmelden."
  },
  "loginForm": {
    "forgotPassword": "Passwort vergessen?",
    "signIn": "Anmelden",
    "register": "Registrieren",
    "dontHaveAccount": "Don’t have an account?",
    "guestCheckout": "Guest Checkout",
    "emailAddress": {
      "label": "Nutzerkennung *",
      "placeholder": "Nutzerkennung"
    },
    "password": {
      "label": "Passwort *",
      "placeholder": "Passwort"
    },
    "wrongEmailFormat": "This is not a valid email format."
  },
  "register": {
    "confirmPassword": {
      "action": "Confirm password",
      "label": "Confirm password",
      "placeholder": "Confirm Password"
    },
    "managementInMyAccount": "Management in My Account.",
    "termsAndConditions": "Terms & Conditions",
    "signIn": "I already have an account. Sign In",
    "register": "Register",
    "confirmNewPassword": "Confirm New Password",
    "resetPassword": "Reset Password",
    "createAccount": "Create an account",
    "title": "Title",
    "firstName": {
      "label": "First name",
      "placeholder": "First name"
    },
    "lastName": {
      "label": "Last name",
      "placeholder": "Last name"
    },
    "emailAddress": {
      "label": "Nutzerkennung *",
      "placeholder": "Nutzerkennung"
    },
    "password": {
      "label": "Password",
      "placeholder": "Password"
    },
    "newPassword": "New Password",
    "emailMarketing": "Use my personal data to receive e-mail newsletters for marketing campaigns. To change your settings, go to Consent Management in My Account.",
    "confirmThatRead": "I am confirming that I have read and agreed with the",
    "selectTitle": "Select Title",
    "passwordMinRequirements": "Password must be six characters minimum, with one uppercase letter, one number, one symbol",
    "bothPasswordMustMatch": "Both password must match",
    "titleRequired": "Title is required.",
    "postRegisterMessage": "Please log in with provided credentials."
  },
  "checkoutLogin": {
    "emailAddress": {
      "label": "Nutzerkennung *",
      "placeholder": "Nutzerkennung"
    },
    "confirmEmail": {
      "label": "Confirm email",
      "placeholder": "Confirm email"
    },
    "continue": "Continue",
    "emailIsRequired": "Invalid email format",
    "emailsMustMatch": "Email does not match"
  },
  "authMessages": {
    "signedOutSuccessfully": "Sie haben sich erfolgreich abgemeldet."
  }
}
